import React from 'react';

import ContentTicker from '@swf/components/ContentTicker/ContentTicker';

import CMSHTML from '../../../../../CMSHTML/CMSHTML';
import type { Props } from '../../TopHeader';

import styles from './RegulatoryHeaderIT.scss';

const RegulatoryHeaderIT: React.FC<Props> = ({ regulatory_header: [{ texts }] }) => (
  <ContentTicker className={styles.regulatoryHeader} interval={6}>
    <CMSHTML content={texts[0].content} />
    <CMSHTML content={texts[1].content} />
  </ContentTicker>
);

export default RegulatoryHeaderIT;
